import { createSelector } from "@ngrx/store";
import { appState } from "src/app/shared/interfaces/appState.interface";

export const selectExchangeState = (state: appState) => state.exchange;

export const selectAllExchanges = createSelector(
  selectExchangeState,
  (exchangeState) => exchangeState.exchangeBoard.all
);